<template>
  <div>
    <div class="dynamicPc" id="dynamicPc">
      <section :class="innerWidth >= 900 ? 'dynamic-top' : 'dynamic-top-ipad'">
        <div
          :class="
            innerWidth >= 900 ? 'dynamic-top-text' : 'dynamic-top-text-ipad'
          "
        >
          <p class="dynamic-top-text-title">小迈动态</p>
          <p>同步企业资讯及文化活动最新动态，促进企业品牌与文化的协同。</p>
        </div>
      </section>

      <!-- 每一块的导航 -->
      <sonNav :sonNavData="sonNavData" ref="sonNav"></sonNav>

      <div class="section-container">
        <!-- 企业资讯 -->
        <section
          class="dynamic-information-pc animated"
          id="dynamicInformation"
          ref="dynamicInformation"
        >
          <h2>企业资讯</h2>
          <div
            class="content"
            v-if="categoryOne.length > 0"
            v-loading="listLoading"
          >
            <div class="article-content" v-if="categoryOne">
              <article-box
                v-for="(item, index) in categoryOne.slice(0, 5)"
                :key="item.id"
                :articleData="item"
                class="article-box"
                @click.native="
                  handleShowDetail(DYNAMICIN_FORMATION, item.id, index)
                "
              />

              <div
                v-if="categoryOne.length > 5"
                class="article-box-more article-box"
                @click="handleLinkMore(DYNAMICIN_FORMATION)"
              >
                查看更多
                <span class="icon-more"></span>
              </div>
            </div>
          </div>

          <img
            class="cube-div big cube_1 aniamtionCode"
            ref="cube_1"
            :src="'//img.ibestfanli.com/officialwebsite/img_block.png'"
          />
        </section>

        <!-- 文化活动 -->
        <section
          class="dynamic-activity-pc animated"
          id="dynamicActivity"
          ref="dynamicActivity"
        >
          <h2>文化活动</h2>
          <div
            class="content"
            v-if="categoryTwo.length > 0"
            v-loading="listLoading"
          >
            <div class="article-content" v-if="categoryTwo">
              <article-box
                v-for="(item, index) in categoryTwo.slice(0, 5)"
                :key="item.id"
                :articleData="item"
                class="article-box"
                @click.native="
                  handleShowDetail(DYNAMIC_ACTIVITY, item.id, index)
                "
              />

              <div
                v-if="categoryTwo.length > 5"
                class="article-box-more article-box"
                @click="handleLinkMore(DYNAMIC_ACTIVITY)"
              >
                查看更多
                <span class="icon-more"></span>
              </div>
            </div>
          </div>

          <img
            class="cube-div big cube_2 aniamtionCode"
            ref="cube_2"
            src="//img.ibestfanli.com/officialwebsite/img_block.png"
          />

          <img
            class="cube-div big cube_3 aniamtionCode"
            ref="cube_3"
            src="//img.ibestfanli.com/officialwebsite/img_block.png"
          />
        </section>
      </div>

      <transition name="fade">
        <TopBtn v-show="showTopBtn"></TopBtn>
      </transition>
    </div>
  </div>
</template>

<script>
import CommonMethod from "utils/CommonMethod";
import TopBtn from "../../../components/topBtn/index";
import sonNav from "../../../components/sonNav/pc.vue";
import ieUtils from "utils/ieUtils";
import $ from "jquery";
import ArticleBox from "../../../components/ArticleBox/pc/index";
import Config from "utils/Config";
import { getArticleListByDetail } from "@/api/dynamic.js";
import { DYNAMICIN_FORMATION, DYNAMIC_ACTIVITY } from "@/data/dynamicData.js";
export default {
  name: "dynamicPc",
  props: {
    // gData: Object,
  },
  components: {
    TopBtn,
    sonNav,
    ArticleBox,
  },
  data() {
    return {
      showTopBtn: 0,
      innerWidth: window.innerWidth,
      commonMethod: null,
      sonNavData: {
        navArr: [
          {
            id: "dynamicInformation",
            name: "企业资讯",
            categoryId: DYNAMICIN_FORMATION,
          },
          {
            id: "dynamicActivity",
            name: "文化活动",
            categoryId: DYNAMIC_ACTIVITY,
          },
        ],
        aniDistance: 80,
        ulWidth: "176px",
        showFixeNav: 0,
        aniClassName: "weakFadeInUpLong",
      },
      categoryOne: [], // tab1数据
      categoryTwo: [], // tab2数据
      listLoading: false,
      DYNAMICIN_FORMATION,
      DYNAMIC_ACTIVITY,
    };
  },
  created() {
    this.commonMethod = new CommonMethod({
      context: this,
      judgeNavToFixedEleName: "#jude-nav-content",
    });

    this.getCategoryList(DYNAMICIN_FORMATION, 6);
    this.getCategoryList(DYNAMIC_ACTIVITY, 6);
  },
  computed: {},
  mounted() {
    this.commonMethod.init();
    window.addEventListener("scroll", this.scrollHandle, true);

    const time = ieUtils.isIE() ? 800 : 500;
    const hash = window.location.hash.slice(1);
    if (!hash) return;

    new Promise((resolve) => {
      // this.$nextTick(() => resolve());
      $(document).ready(() => resolve());
    })
      .then(() => {
        return new Promise((resolve) => setTimeout(() => resolve(), time));
      })
      .then(() => {
        this.$refs.sonNav.toAnchorPoint(hash);
      });
  },
  methods: {
    // 分Id取文章列表
    async getCategoryList(categoryId, pageSize) {
      try {
        this.listLoading = true;
        const paramMap = {
          categoryId: categoryId,
          pageSize: pageSize,
        };

        const res = await getArticleListByDetail(paramMap);
        if (!res.data) return;
        const listData = res.data.page;

        if (listData.list.length === 0) {
          // 某个tab没内容，处理一下sonNav
          let newNav = this.sonNavData.navArr.filter(
            (item) => item.categoryId !== categoryId
          );
          this.sonNavData.navArr = newNav;
          this.sonNavData.ulWidth = "64px";
        }

        if (categoryId === DYNAMICIN_FORMATION) {
          this.categoryOne = listData.list;
        } else if (categoryId === DYNAMIC_ACTIVITY) {
          this.categoryTwo = listData.list;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.listLoading = false;
      }
    },
    scrollHandle() {
      this.commonMethod.modelFadeInup(
        "dynamicInformation",
        750,
        "weakFadeInUpLong"
      );
      this.commonMethod.modelFadeInup(
        "dynamicActivity",
        750,
        "weakFadeInUpLong"
      );

      // 方块动画
      this.commonMethod.cubeAnimation(
        "cube_1",
        500,
        "once11",
        "cubeMoveDown",
        "cubeMoveDown2"
      );
      this.commonMethod.cubeAnimation(
        "cube_2",
        10,
        "once22",
        "cubeMoveDown13",
        "cubeMoveDown14"
      );
      this.commonMethod.cubeAnimation(
        "cube_3",
        600,
        "once33",
        "cubeMoveDown13",
        "cubeMoveDown14"
      );

      this.$set(this.sonNavData, "showFixeNav", this.commonMethod.navIsTop());
      this.commonMethod.showAnchorContentEvt();

      this.showTopBtnEvt();
    },
    toAnchorPoint(index) {
      document.getElementsByTagName("body")[0].scrollTop =
        this.commonMethod.anchorPointDistacneArr[index];
    },
    showTopBtnEvt() {
      const { top, height } = document
        .querySelector(".dynamicPc")
        .getBoundingClientRect();

      if (Math.abs(top) >= height / 2) {
        this.showTopBtn = 1;
      } else {
        this.showTopBtn = 0;
      }
    },
    handleLinkMore(categoryId) {
      // categoryId : 为文章分类Id
      window.location.href = `${Config.domain}/dynamicList.html?categoryId=${categoryId}`;
    },
    handleShowDetail(categoryId, articleId, index) {
      window.location.href = `${Config.domain}/dynamicDetail.html?categoryId=${categoryId}&id=${articleId}&index=${index}`;
    },
  },
};
</script>

<style lang="less" scoped>
section {
  position: relative;
}
.section-container {
  position: relative;
}
.big {
  display: block;
}
.small {
  display: none;
}

.content {
  padding-top: 60px;
  margin: 0 auto;
}

// 方法
.h2Pc {
  margin: 0;
  font-size: 36px;
  text-align: center;
  padding-top: 80px;
}

/* -------- 样式 ----- */
h2 {
  .h2Pc;
}

.dynamicPc {
  width: 100%;
  overflow: hidden;
  padding-bottom: 80px;
}

.dynamic-top {
  position: relative;
  width: 100%;
  padding-top: 25%;
  background-image: url("~@/assets/img/pc/dynamic/top/banner_dynamic@2x.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  // .allCenter;
  .dynamic-top-text {
    position: absolute;
    display: inline-block;
    top: 128px;
    left: 50%;
    transform: translateX(-50%);
    width: 1200px;
    .dynamic-top-text-title {
      width: 224px;
      height: 54px;
      font-size: 44px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 54px;
      padding-bottom: 20px;
    }
    p {
      width: 580px;
      height: 94px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 40px;
    }
  }
}

.dynamic-top-ipad {
  // .imgInfoP(100%, 478px, "about/top/img_ipad_img_aboutus.png");
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 42.8%;
  background-image: url("~@/assets/img/pc/dynamic/top/banner_dynamic_ipad@2x.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .dynamic-top-text-ipad {
    position: absolute;
    display: inline-block;
    top: 20%;
    left: 8%;
    width: 436px;
    .dynamic-top-text-title {
      width: 120px;
      height: 41px;
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222222;
      line-height: 41px;
    }
    p {
      width: 310px;
      height: 63px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 32px;
    }
  }
}

.dynamic-information-pc,
.dynamic-activity-pc {
  .content {
    width: 1200px;
    font-family: PingFangSC-Regular, PingFang SC;
    position: relative;

    .article-content {
      position: relative;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 60px 24px;

      .article-box {
        width: 384px;
        height: 508px;
      }

      .article-box-more {
        border: 1px solid #e1e1e1;
        background: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 28px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease-in;

        .icon-more {
          width: 14px;
          height: 16px;
          background-image: url("~@/assets/img/pc/dynamic/article/icon_more@2x.png");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          margin-left: 12px;
        }
      }

      .article-box-more:hover {
        transform: translateY(-22px);
        box-shadow: 0px 11px 63px 0px #eff4fa;
        border-color: transparent;
      }
    }
  }

  .cube_1 {
    width: 450px;
    height: 450px;
    top: 20px;
    right: -215px;
    transform: rotate(-90deg);
  }

  .cube_2 {
    width: 900px;
    height: 900px;
    top: -130px;
    left: -600px;
    transform: translateY(0) rotate(60deg);
  }

  .cube_3 {
    width: 300px;
    height: 300px;
    top: 600px;
    right: 40px;
    transform: translateY(0) rotate(60deg);
  }
}

@media screen and (min-width: 1200px) {
  .dynamic-information-pc .content {
    &::after {
      content: "";
      position: absolute;
      left: -100px;
      top: 240px;
      .imgInfoP(217px, 107px, "dynamic/article/img_matrix@2x.png");
      z-index: -1;
    }
  }
}

// 大屏ipad 1024 （基准1000）
@media screen and (min-width: 900px) and (max-width: 1200px) {
  .safeArea {
    width: 844px;
  }
  .content {
    .safeArea !important;
    padding-top: 60px;
    margin: 0 auto;
  }

  .small {
    display: block !important;
  }
  .big {
    display: none;
  }

  h3 {
    padding-top: 12px !important;
  }

  .dynamic-top {
    position: relative;
    width: 100%;
    padding-top: 43%;
    background-image: url("~@/assets/img/pc/dynamic/top/banner_dynamic_ipad@2x.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    .dynamic-top-text {
      position: absolute;
      display: inline-block;
      top: 84px;
      left: 50%;
      transform: translateX(-50%);
      width: 844px;
      .dynamic-top-text-title {
        width: 219px;
        height: 54px;
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 54px;
      }
      p {
        width: 413px;
        height: 114px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 42px;
      }
    }
  }

  .dynamic-information-pc,
  .dynamic-activity-pc {
    .content {
      .article-content {
        position: relative;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 60px 24px;

        .article-box {
          width: 420px;
          height: 540px;
        }
        .article-box:hover {
          transform: inherit;
        }
      }
    }
  }
}

// ipad
@media screen and (min-width: 700px) /* (min-width: 768px) */ and (max-width: 900px) {
  .safeArea {
    width: 648px;
  }
  .content {
    .safeArea !important;
    padding-top: 45px;
    margin: 0 auto;
  }
  .small {
    display: block !important;
  }
  .big {
    display: none;
  }
  h1 {
    font-size: 27px !important;
  }
  h2 {
    font-size: 27px;
    // padding-top: 60px;
  }

  .dynamic-top {
    .imgInfoP(100%, 323px, "~@/assets/img/pc/dynamic/article/icon_more@2x.png");
    background-size: center top;
  }

  .dynamic-information-pc,
  .dynamic-activity-pc {
    .content {
      .article-content {
        position: relative;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 60px 24px;

        .article-box {
          width: 312px;
          height: 500px;
        }
        .article-box:hover {
          transform: inherit;
        }
      }
    }
  }
}
</style>